import router from '@/router';
import store from '@/store'
import { SET_TIMEOUT_ERROR, SET_IS_LOADING } from "@/store/mutations.type";

export function handle(error) {
    if (error.response.status == 404) {
        let message = Object.prototype.hasOwnProperty.call(error.response.data, 'errorMessage') ? error.response.data.errorMessage : "Data not Found, Please try after sometime."
        store.commit(SET_TIMEOUT_ERROR, { title: 'Error', message: message, isOpen: true })
        store.commit(SET_IS_LOADING, false)
        throw error
    }
    else if (error.response.status >= 500) {
        let message = Object.prototype.hasOwnProperty.call(error.response.data, 'errorMessage') ? error.response.data.errorMessage : "Error occurred, Please contact MiRus admin."
        router.push({
            name: "ErrorPage",
            params: { message: message },
        });
    }
    else {
        throw error
    }
}